// 白钻查询
<template>
    <div class="select-container">
        <!-- 顶部导航栏 -->
        <div class="top-header">
            <div class="header-left" @click="goBack">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="header-center">
                <h3>Search</h3>
            </div>
            <div class="header-right">
                <!-- 占位，保持布局平衡 -->
            </div>
        </div>

        <!-- 钻石大图 
        <div class="diamond-banner">
            <img :src="bannerImage" alt="钻石" />
        </div>
        -->
        <!-- 搜索条件区域 -->
        <div class="search-section">
            <div class="search-content">
                <!-- 形状选择 -->
                <div class="filter-section">
                    <div class="filter-title">{{ $t('common.Shape') }}</div>
                    <div class="filter-content shape-content">
                        <div v-for="(shape, index) in shapeList" :key="index" 
                             class="shape-item" 
                             :class="{ active: checkboxGroup1.includes(shape.value) }"
                             @click="toggleShape(shape.value)">
                            <div class="shape-icon" :class="'el-icon-' + getShapeIcon(shape.value)"></div>
                            <div class="shape-name">{{ $t('common.' + shape.value) }}</div>
                        </div>
                    </div>
                </div>
                <!-- 地点选择 -->
                <div class="filter-section">
                    <div class="filter-title">{{ $t('common.Place') }}</div>
                    <div class="filter-content color-content">
                        <div v-for="place in placeList" :key="place" 
                             class="color-item" 
                             :class="{ active: checkboxGroup12.includes(place) }"
                             @click="togglePlace(place)">
                            {{place}}
                        </div>
                    </div>
                    <div class="filter-title">{{ $t('common.SaleStatus') }}</div>
                    <div class="filter-content color-content">
                        <div v-for="sale_status in sale_statusList" :key="sale_status" 
                             class="color-item" 
                             :class="{ active: checkboxGroup13.includes(sale_status) }"
                             @click="toggleSaleStatus(sale_status)">
                            {{sale_status}}
                        </div>
                    </div>
                </div>
                <!-- 克拉选择 -->
                <div class="filter-section">
                    <div class="filter-title">{{ $t('common.Weight') }}</div>
                    <div class="filter-content carat-content">
                        <div class="carat-range">
                            <div class="carat-item" :class="{ active: query.ct == '3' }" @click="ctChange('3')">0.3</div>
                            <div class="carat-item" :class="{ active: query.ct == '4' }" @click="ctChange('4')">0.4</div>
                            <div class="carat-item" :class="{ active: query.ct == '5' }" @click="ctChange('5')">0.5</div>
                            <div class="carat-item" :class="{ active: query.ct == '6' }" @click="ctChange('6')">0.6</div>
                            <div class="carat-item" :class="{ active: query.ct == '7' }" @click="ctChange('7')">0.7</div>
                            <div class="carat-item" :class="{ active: query.ct == '8' }" @click="ctChange('8')">0.8</div>
                            <div class="carat-item" :class="{ active: query.ct == '9' }" @click="ctChange('9')">0.9</div>
                            <div class="carat-item" :class="{ active: query.ct == '10' }" @click="ctChange('10')">1.00</div>
                            <div class="carat-item" :class="{ active: query.ct == '11' }" @click="ctChange('11')">1.10</div>
                            <div class="carat-item" :class="{ active: query.ct == '12' }" @click="ctChange('12')">1.50</div>
                            <div class="carat-item" :class="{ active: query.ct == '13' }" @click="ctChange('13')">2.00</div>
                            <div class="carat-item" :class="{ active: query.ct == '14' }" @click="ctChange('14')">3.00</div>
                            <div class="carat-item" :class="{ active: query.ct == '15' }" @click="ctChange('15')">4.00</div>
                            <div class="carat-item" :class="{ active: query.ct == '16' }" @click="ctChange('16')">5.00</div>
                        </div>
                        <div class="carat-custom">
                            <el-input v-model="query.ct1" placeholder="Min" class="carat-input"></el-input>
                            <span class="separator">~</span>
                            <el-input v-model="query.ct2" placeholder="Max" class="carat-input"></el-input>
                            <span>ct</span>
                        </div>
                    </div>
                </div>

                <!-- 颜色选择 -->
                <div class="filter-section">
                    <div class="filter-title">{{ $t('common.Color') }}</div>
                    <div class="filter-content color-content">
                        <div v-for="color in colorlist" :key="color" 
                             class="color-item" 
                             :class="{ active: checkboxGroup2.includes(color) }"
                             @click="toggleColor(color)">
                            {{color}}
                        </div>
                    </div>
                </div>
                
                <!-- 净度选择 -->
                <div class="filter-section">
                    <div class="filter-title">{{ $t('common.Clarity') }}</div>
                    <div class="filter-content clarity-content">
                        <div v-for="cla in clalist" :key="cla" 
                             class="clarity-item" 
                             :class="{ active: checkboxGroup3.includes(cla) }"
                             @click="toggleClarity(cla)">
                            {{cla}}
                        </div>
                    </div>
                </div>

                <!-- 净度选择 
                <div class="filter-section">
                    <div class="filter-title">净度</div>
                    <div class="filter-content clarity-content">
                        <div v-for="cla in clalist" :key="cla" 
                             class="clarity-item" 
                             :class="{ active: checkboxGroup3.includes(cla) }"
                             @click="toggleClarity(cla)">
                            {{cla}}
                        </div>
                    </div>
                </div>-->

                <!-- 快捷选择按钮
                <div class="filter-section">
                    <div class="filter-title">快捷</div>
                    <div class="filter-content quick-content">
                        <div class="quick-item" @click="select3exn">3EX-N</div>
                        <div class="quick-item" @click="select3vgn">3VG</div>
                        <div class="quick-item" @click="select3gdn">3GD</div>
                        <div class="quick-item" @click="select3frn">3FR</div>
                    </div>
                </div> -->

                <!-- 快捷选择 -->
                <div class="filter-section">
                    <div class="filter-title">{{ $t('common.Selection') }}</div>
                    <div class="filter-content quick-content">
                        <div class="quick-item" @click="select3exn">3EX-N</div>
                        <div class="quick-item" @click="select3vgn">3VG</div>
                        <div class="quick-item" @click="select3gdn">3GD</div>
                        <div class="quick-item" @click="select3frn">3FR</div>
                    </div>
                </div>
                
                <!-- 切工选择 -->
                <div class="filter-section">
                    <div class="filter-title">{{ $t('common.Cut') }}</div>
                    <div class="filter-content cut-content">
                        <div v-for="cut in cutlist" :key="cut" 
                             class="cut-item" 
                             :class="{ active: checkboxGroup4.includes(cut) }"
                             @click="toggleCut(cut)">
                            {{cut}}
                        </div>
                    </div>
                    <div class="filter-title">{{ $t('common.Polish') }}</div>
                    <div class="filter-content polish-content">
                        <div v-for="pol in pollist" :key="pol" 
                             class="polish-item" 
                             :class="{ active: checkboxGroup5.includes(pol) }"
                             @click="togglePolish(pol)">
                            {{pol}}
                        </div>
                    </div>
                    <div class="filter-title">{{ $t('common.Sym') }}</div>
                    <div class="filter-content symmetry-content">
                        <div v-for="sym in pollist" :key="sym" 
                             class="symmetry-item" 
                             :class="{ active: checkboxGroup6.includes(sym) }"
                             @click="toggleSymmetry(sym)">
                            {{sym}}
                        </div>
                    </div>
                    <div class="filter-title">{{ $t('common.Flu') }}</div>
                    <div class="filter-content fluorescence-content">
                        <div v-for="fl in fllist" :key="fl" 
                             class="fluorescence-item" 
                             :class="{ active: checkboxGroup7.includes(fl) }"
                             @click="toggleFluorescence(fl)">
                            {{fl}}
                        </div>
                    </div>
                </div>
                
                <!-- 抛光选择 
                <div class="filter-section">
                    
                </div>-->
                
                <!-- 对称选择
                <div class="filter-section">
                    
                </div> -->
                
                <!-- 荧光选择
                <div class="filter-section">
                    
                </div> -->

                <!-- 证书号 -->
                <div class="filter-section">
                    <div class="filter-title">{{ $t('common.CertNo') }}</div>
                    <el-input 
                        v-model="query.cert_no" 
                        :placeholder="$t('common.pleaseInput')"
                        class="cert-input">
                    </el-input>
                </div>
            </div>
            
            <!-- 搜索按钮 -->
            <div :class="['action-buttons', { 'safari-only': isSafari }]">
                <el-button @click="resetForm('query')" class="reset-btn" size="small">{{ $t('button.reset') }}</el-button>
                <el-button type="primary" @click="selectDiamondInfoList" class="search-btn" size="small">{{ $t('button.search') }}</el-button>
            </div>
        </div>

        <!-- 对话框 
        <div class="text e-info auto-table">
            <el-dialog :title="$t('common.Order')" :visible.sync = "dialogTableVisible3" @close="closeSava" 
                width="150px" center :close-on-click-modal="false" :append-to-body="true">
                <el-form :inline="true" label-width="150px" size="small" 
                    :model="addDataForm3" class="demo-form-inline" ref="addDataForm3" :rules="rules3">
                    <el-form-item prop="vipCount" :label="$t('common.Customer') + ':'" style="width: 100%;float:left">
                        <el-input v-model="addDataForm3.vipCount" :placeholder="$t('common.pleaseInput')"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaAllOrderInfo">{{ $t('button.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>
        
        <el-dialog
          title="Image"
          :visible.sync="imageDialogVisible"
          width="90%"
          center
          append-to-body
          :close-on-click-modal="true"
          :before-close="handleImageDialogClose">
          <div class="image-dialog-content">
            <img :src="currentImageUrl" alt="Image" class="diamond-image">
          </div>
        </el-dialog>
        
        <el-dialog
          title="Video"
          :visible.sync="videoDialogVisible"
          width="90%"
          center
          append-to-body
          :close-on-click-modal="true"
          :before-close="handleVideoDialogClose">
          <div class="video-dialog-content">
            <video 
              :src="currentVideoUrl" 
              class="diamond-video" 
              controls 
              autoplay
              controlsList="nodownload">
              Your browser does not support the video playback
            </video>
          </div>
        </el-dialog>
        
        <el-dialog title="钻石报价" :visible.sync="dialogTableVisible7" @close="closeSava" 
            width="90%" center :close-on-click-modal="false" append-to-body>
            <el-form :inline="true" label-width="100px" size="small"
                    :model="baojiaform" class="demo-form-inline" ref="baojiaform">
                <el-form-item prop="all_new_dis" label="折扣加/减：" label-width="90px">
                    <el-input v-model="baojiaform.all_new_dis" placeholder="请输入" @change="dis_change"></el-input>
                </el-form-item>
                <el-form-item prop="all_sale_rate" label="销售汇率：" label-width="90px">
                    <el-input v-model="baojiaform.all_sale_rate" placeholder="请输入" @change="rate_change"></el-input>
                </el-form-item>
                <el-button type="primary" @click="copyPriceInfo" plain size="small">复制报价信息</el-button>
            </el-form>
            <div class="price-summary">
                <div>总价: ¥{{ totalPrice }} / ${{ totalUsdPrice }}</div>
                <div>总重: {{ ct_total }}ct</div>
                <div>数量: {{ data_len }}颗</div>
            </div>
        </el-dialog>
        -->
    </div>
</template>
<script>
    import util from '../../common/js/util.js';
    export default {
        data() {
            return {
                bannerImage: require('../../assets/images/banner3.png'),
                isSafari: false, // 是否为 Safari 浏览器
                isExpand: false,
                isAble: true,
                visibleLine: 'none',
                isdisabled: false,
                dialogTableVisible: false,
                dialogTableVisible3: false,
                dialogTableVisible7: false,
                checkboxGroup1: [],
                checkboxGroup2: [],
                checkboxGroup3: [],
                checkboxGroup4: [],
                checkboxGroup5: [],
                checkboxGroup6: [],
                checkboxGroup7: [],
                checkboxGroup8: [],
                checkboxGroup9: [],
                checkboxGroup10: [],
                checkboxGroup11: [],
                checkboxGroup12: [],
                checkboxGroup13: [],
                shapeList: [{'value':'Round'},{'value':'Princess'},{'value':'Radiant'}
                            ,{'value':'Asscher'},{'value':'Marquise'},{'value':'Oval'}
                            ,{'value':'Emerald'},{'value':'Pear'},{'value':'Heart'}
                            ,{'value':'Cushion'},{'value':'Others'},{'value':'Triangle'}],
                shapeList1: [{'value':'圆形'},{'value':'公主方'},{'value':'雷迪恩'}
                            ,{'value':'阿斯切'},{'value':'马眼'},{'value':'椭圆形'}
                            ,{'value':'祖母绿'},{'value':'梨形'},{'value':'心形'}
                            ,{'value':'垫形'},{'value':'其他'},{'value':'三角形'}],
                colList: [{'value':'D'},{'value':'E'},{'value':'F'}
                            ,{'value':'G'},{'value':'H'},{'value':'I'}
                            ,{'value':'J'},{'value':'K'},{'value':'L'}
                            ,{'value':'M-N'},{'value':'O-Z'}],
                claList: [{'value':'FL'},{'value':'IF'},{'value':'VVS1'}
                            ,{'value':'VVS2'},{'value':'VS1'},{'value':'VS2'}
                            ,{'value':'SI1'},{'value':'SI2'},{'value':'SI3'}
                            ,{'value':'I1'},{'value':'I2'}],
                cutList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'},{'value':'NN'}],
                polList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'}],
                flList: [{'value':'N'},{'value':'VSL'},{'value':'F'}
                            ,{'value':'M'},{'value':'S'},{'value':'VS'}],
                placeList1: [{'value':'HK'},{'value':'CHINA'},{'value':'SZ'}
                            ,{'value':'INDIA'},{'value':'LAB'},{'value':'SH'},{'value':'H-K'}],
                certList: [{'value':'GIA'},{'value':'NGTC'},{'value':'IGI'}
                            ,{'value':'HRD'},{'value':'None'},{'value':'Other'}],
                inv_statusList: [{'value':'在库'},{'value':'不在库'}],
                sale_statusList: ['在售','保留','借货','全款借货','确认销售'],
                placeList: ['HK','CN','SZ','SH','H-K'],
                colorlist: ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M-N', 'O-Z'],
                clalist: ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'SI3','I1','I2'],
                cutlist: ['EX', 'VG', 'GD', 'FR', 'PR', 'NN'],
                pollist: ['EX', 'VG', 'GD', 'FR', 'PR'],
                fllist: ['N', 'VSL', 'F', 'M', 'S', 'VS'],
                certlist: ['GIA', 'NGTC', 'IGI', 'HRD', 'None', 'Other'],
                inv_status: '',
                addDataForm: {},
                addDataForm2: {},
                addDataForm3: {
                    'sale_status': '1',
                    'tiaodian1': '1',
                    'date_long': '24h',
                    'vipCount': sessionStorage.getItem('userName')
                },
                addDataForm4: {},
                addDataForm5: {},
                addDataForm6: {},
                dataOnLineListSelections: [],
                certnoList: [],
                certnoStr: '',
                sale_priceList: [],
                idList: [],
                idStr: '',
                cert_noStr: '',
                sale_priceStr: '',
                diamondInfoList: [],
                diamondAllInfoList: {},
                diamondCZInfoList: {},
                diamondRapnetInfoList: {},
                imgViewerVisible:false,
                ratevalue: '',
                ct_total: 0,
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                // 查询
                query: {
                    sale_status: '在售',
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                    addPoint: 0,
                    milkCoffeeGreen: '',
                    noBlack: false,
                    cleanEye: false,
                    hasImage: false,
                    inStock: false,
                    isClosed: false,
                    hasSpecialPrice: false,
                    supplier: '',
                    stockNumber: ''
                },
                column: 'sale_price',
                order: 'asc',
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 20,
                    total: 0
                },
                rules3:{
                    vipCount:[
                        {
                            required:true,
                            message:'Please input customer!',
                            trigger:'blur'
                        }
                    ]
                },
                imageDialogVisible: false,
                currentImageUrl: '',
                videoDialogVisible: false,
                currentVideoUrl: '',
                baojiaform: {
                    all_new_dis: '',
                    all_sale_rate: ''
                },
                totalPrice: 0,
                totalUsdPrice: 0
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectDiamondInfoList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectDiamondInfoList();
            },
            // shape 形状
            toggleShape(value) {
                if (this.checkboxGroup1.includes(value)) {
                    this.checkboxGroup1 = this.checkboxGroup1.filter((v) => v !== value);
                } else {
                    this.checkboxGroup1.push(value);
                }
                this.query.shape = this.checkboxGroup1.join();
            },
            // 获取形状图标名称
            getShapeIcon(shape) {
                const shapeMap = {
                    'Round': 'round',
                    'Princess': 'princess',
                    'Radiant': 'radiant',
                    'Asscher': 'asscher',
                    'Marquise': 'marquise',
                    'Oval': 'oval',
                    'Emerald': 'emerald',
                    'Pear': 'pear1',
                    'Heart': 'heart',
                    'Cushion': 'cushion',
                    'Others': 'others',
                    'Triangle': 'triangle'
                };
                return shapeMap[shape] || 'round';
            },
            // 返回
            goBack() {
                this.$router.push('/index');
            },
            // 颜色
            toggleColor(value) {
                if (this.checkboxGroup2.includes(value)) {
                    this.checkboxGroup2 = this.checkboxGroup2.filter((v) => v !== value);
                } else {
                    this.checkboxGroup2.push(value);
                }
                this.query.col = this.checkboxGroup2.join();
            },
            // 地点
            togglePlace(value) {
                if (this.checkboxGroup12.includes(value)) {
                    this.checkboxGroup12 = this.checkboxGroup12.filter((v) => v !== value);
                } else {
                    this.checkboxGroup12.push(value);
                }
                this.query.place = this.checkboxGroup12.join();
            },
            // 销售状态
            toggleSaleStatus(value) {
                if (this.checkboxGroup13.includes(value)) {
                    this.checkboxGroup13 = this.checkboxGroup13.filter((v) => v !== value);
                } else {
                    this.checkboxGroup13.push(value);
                }
                this.query.sale_status = this.checkboxGroup13.join();
            },
            // 净度
            toggleClarity(value) {
                if (this.checkboxGroup3.includes(value)) {
                    this.checkboxGroup3 = this.checkboxGroup3.filter((v) => v !== value);
                } else {
                    this.checkboxGroup3.push(value);
                }
                this.query.cla = this.checkboxGroup3.join();
            },
            // 切工
            toggleCut(value) {
                if (this.checkboxGroup4.includes(value)) {
                    this.checkboxGroup4 = this.checkboxGroup4.filter((v) => v !== value);
                } else {
                    this.checkboxGroup4.push(value);
                }
                this.query.cut = this.checkboxGroup4.join();
            },
            // 抛光
            togglePolish(value) {
                if (this.checkboxGroup5.includes(value)) {
                    this.checkboxGroup5 = this.checkboxGroup5.filter((v) => v !== value);
                } else {
                    this.checkboxGroup5.push(value);
                }
                this.query.pol = this.checkboxGroup5.join();
            },
            // 对称
            toggleSymmetry(value) {
                if (this.checkboxGroup6.includes(value)) {
                    this.checkboxGroup6 = this.checkboxGroup6.filter((v) => v !== value);
                } else {
                    this.checkboxGroup6.push(value);
                }
                this.query.sym = this.checkboxGroup6.join();
            },
            // 荧光
            toggleFluorescence(value) {
                if (this.checkboxGroup7.includes(value)) {
                    this.checkboxGroup7 = this.checkboxGroup7.filter((v) => v !== value);
                } else {
                    this.checkboxGroup7.push(value);
                }
                this.query.fl = this.checkboxGroup7.join();
            },
            // 证书
            toggleCert(value) {
                if (this.checkboxGroup8.includes(value)) {
                    this.checkboxGroup8 = this.checkboxGroup8.filter((v) => v !== value);
                } else {
                    this.checkboxGroup8.push(value);
                }
                this.query.cert = this.checkboxGroup8.join();
            },
            // 联动赋值重量
            ctChange(val) {
                if(val == 3) {
                    this.$set(this.query,'ct1','0.30');
                    this.$set(this.query,'ct2','0.39');
                }else if(val == 4) {
                    this.$set(this.query,'ct1','0.40');
                    this.$set(this.query,'ct2','0.49');
                }else if(val == 5) {
                    this.$set(this.query,'ct1','0.50');
                    this.$set(this.query,'ct2','0.59');
                }else if(val == 6) {
                    this.$set(this.query,'ct1','0.60');
                    this.$set(this.query,'ct2','0.69');
                }else if(val == 7) {
                    this.$set(this.query,'ct1','0.70');
                    this.$set(this.query,'ct2','0.79');
                }else if(val == 8) {
                    this.$set(this.query,'ct1','0.80');
                    this.$set(this.query,'ct2','0.89');
                }else if(val == 9) {
                    this.$set(this.query,'ct1','0.90');
                    this.$set(this.query,'ct2','0.99');
                }else if(val == 10) {
                    this.$set(this.query,'ct1','1.00');
                    this.$set(this.query,'ct2','1.09');
                }else if(val == 11) {
                    this.$set(this.query,'ct1','1.10');
                    this.$set(this.query,'ct2','1.49');
                }else if(val == 12) {
                    this.$set(this.query,'ct1','1.50');
                    this.$set(this.query,'ct2','1.99');
                }else if(val == 13) {
                    this.$set(this.query,'ct1','2.00');
                    this.$set(this.query,'ct2','2.99');
                }else if(val == 14) {
                    this.$set(this.query,'ct1','3.00');
                    this.$set(this.query,'ct2','3.99');
                }else if(val == 15) {
                    this.$set(this.query,'ct1','4.00');
                    this.$set(this.query,'ct2','4.99');
                }else if(val == 16) {
                    this.$set(this.query,'ct1','5.00');
                    this.$set(this.query,'ct2','9.99');
                }
            },
            // 手动输入重量
            ctSelect(e) {
                let value = e.target.value;
                if(value) {
                    console.log(value)
                    if(value.includes('-')){
                        this.$nextTick(()=> {
                            this.$set(this.query,'ct',value);
                        })
                        // this.query.ct = value;
                        let valArr = value.split('-');
                        this.$set(this.query,'ct1',valArr[0]);
                        this.$set(this.query,'ct2',valArr[1]);
                        console.log(this.query.ct1);
                        console.log(this.query.ct2);
                    }
                }
            },
            // 手动输入重量2
            ctChange3(value) {
                if(value) {
                    this.$set(this.query,'ct','');
                    console.log(value)
                    this.$set(this.query,'ct1',value);
                    console.log(this.query.ct1);
                }
            },
            ctChange4(value) {
                if(value) {
                    console.log(value)
                    this.$set(this.query,'ct2',value);
                    console.log(this.query.ct2);
                }
            },
            // 3EXN
            select3exn() {
                this.checkboxGroup4 = ['EX'];
                this.checkboxGroup5 = ['EX'];
                this.checkboxGroup6 = ['EX'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX';
                this.query.pol = 'EX';
                this.query.sym = 'EX';
                this.query.fl = 'N';
            },
            // 3VGN
            select3vgn() {
                this.checkboxGroup4 = ['EX','VG'];
                this.checkboxGroup5 = ['EX','VG'];
                this.checkboxGroup6 = ['EX','VG'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX,VG';
                this.query.pol = 'EX,VG';
                this.query.sym = 'EX,VG';
                this.query.fl = 'N';
            },
            // 3GDN
            select3gdn() {
                this.checkboxGroup4 = ['EX','VG','GD'];
                this.checkboxGroup5 = ['EX','VG','GD'];
                this.checkboxGroup6 = ['EX','VG','GD'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX,VG,GD';
                this.query.pol = 'EX,VG,GD';
                this.query.sym = 'EX,VG,GD';
                this.query.fl = 'N';
            },
            // 3FRN
            select3frn() {
                this.checkboxGroup4 = ['EX','VG','GD','FR'];
                this.checkboxGroup5 = ['EX','VG','GD','FR'];
                this.checkboxGroup6 = ['EX','VG','GD','FR'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX,VG,GD,FR';
                this.query.pol = 'EX,VG,GD,FR';
                this.query.sym = 'EX,VG,GD,FR';
                this.query.fl = 'N';
            },
            // 选择器选择数据，加工数据证书号、统计数据
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 计算总销售额
                let sale_rap1 = 0;
                let sale_usd1 = 0;
                let sale_price1 = 0;
                let ct1 = 0;
                for(let a = 0; a < this.data_len; a++) {
                    console.log(val[a].sale_price);
                    console.log(val[a].ct);
                    // 进货价
                    sale_rap1 += val[a].sale_rap;
                    // 销售价格
                    sale_usd1 += val[a].sale_usd;
                    sale_price1 += val[a].sale_price;
                    // 重量
                    ct1 += parseFloat(val[a].ct);
                }
                // 进货价
                this.sale_rap_total = sale_rap1.toFixed(2);
                // 销售价格
                this.sale_usd_total = sale_usd1.toFixed(2);
                this.sale_price_total = sale_price1.toFixed(2);
                // 总重量
                this.ct_total = ct1.toFixed(2);
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                this.certnoList = val.map((item) => item.cert_no + '\n');
                this.sale_priceList = val.map((item) => item.sale_price);
                //数据选中后，显示按钮
                if(this.certnoList.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
            },
            /*
            // 获取证书号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',','');
                console.log(this.certnoStr)
                // 复制
                this.copyText(this.certnoStr);
            },
            // 带证书号复制
            selectCertnoCopy() {
                this.dialogTableVisible7 = true;
                
                // 初始化汇率
                if (!this.baojiaform.all_sale_rate && this.ratevalue) {
                    this.baojiaform.all_sale_rate = this.ratevalue;
                }
                
                // 计算总价
                this.calculateTotalPrice();
            },
            
            // 折扣变化
            dis_change() {
                this.calculateTotalPrice();
            },
            
            // 汇率变化
            rate_change() {
                this.calculateTotalPrice();
            },
            
            // 计算总价
            calculateTotalPrice() {
                if (!this.dataOnLineListSelections || this.dataOnLineListSelections.length === 0) {
                    this.totalPrice = 0;
                    this.totalUsdPrice = 0;
                    return;
                }
                
                let totalRmb = 0;
                let totalUsd = 0;
                
                // 遍历选中的钻石
                for (let item of this.dataOnLineListSelections) {
                    // 计算调整后的价格
                    let newDis = parseFloat(item.new_dis);
                    let saleRate = parseFloat(this.ratevalue);
                    
                    // 如果有输入折扣调整，应用它
                    if (this.baojiaform.all_new_dis) {
                        newDis = newDis + parseFloat(this.baojiaform.all_new_dis);
                    }
                    
                    // 如果有输入汇率，应用它
                    if (this.baojiaform.all_sale_rate) {
                        saleRate = parseFloat(this.baojiaform.all_sale_rate);
                    }
                    
                    // 计算美元价格 = (Rap价格 * (1 + 折扣/100) * 克拉)
                    let usdPrice = (item.sale_rap * (1 + (newDis / 100)) * parseFloat(item.ct)).toFixed(2);
                    
                    // 计算人民币价格 = 美元价格 * 汇率
                    let rmbPrice = Math.round(saleRate * usdPrice);
                    
                    totalRmb += rmbPrice;
                    totalUsd += parseFloat(usdPrice);
                }
                
                this.totalPrice = Math.round(totalRmb);
                this.totalUsdPrice = totalUsd.toFixed(2);
            },
            
            // 复制报价信息
            copyPriceInfo() {
                if (!this.dataOnLineListSelections || this.dataOnLineListSelections.length === 0) {
                    this.$message({
                        message: "No diamond selected",
                        type: "warning",
                    });
                    return;
                }
                
                var dataCopyStr = '';
                var forlist = this.dataOnLineListSelections;
                
                for (var i = 0; i < forlist.length; i++) {
                    let placeStr = '深圳';
                    if (forlist[i].place === 'HK' || forlist[i].place === 'hk' || forlist[i].place === 'H-K') {
                        placeStr = '香港';
                    } else if (forlist[i].place === 'CHINA' || forlist[i].place === 'china' || forlist[i].place === 'CN') {
                        placeStr = '中国';
                    } else if (forlist[i].place === 'sh' || forlist[i].place === 'SH') {
                        placeStr = '上海';
                    }
                    
                    // 计算调整后的价格
                    let newDis = parseFloat(forlist[i].new_dis);
                    let saleRate = parseFloat(this.ratevalue);
                    
                    // 如果有输入折扣调整，应用它
                    if (this.baojiaform.all_new_dis) {
                        newDis = newDis + parseFloat(this.baojiaform.all_new_dis);
                    }
                    
                    // 如果有输入汇率，应用它
                    if (this.baojiaform.all_sale_rate) {
                        saleRate = parseFloat(this.baojiaform.all_sale_rate);
                    }
                    
                    // 计算美元价格 = (Rap价格 * (1 + 折扣/100) * 克拉)
                    let usdPrice = (forlist[i].sale_rap * (1 + (newDis / 100)) * parseFloat(forlist[i].ct)).toFixed(2);
                    
                    // 计算人民币价格 = 美元价格 * 汇率
                    let rmbPrice = Math.round(saleRate * usdPrice);
                    
                    var dataCopy = forlist[i].shape + ', ' + forlist[i].ct + ', ' + forlist[i].col + ', ' + forlist[i].cla
                            + ', ' + forlist[i].cut + ', ' + forlist[i].pol + ', ' + forlist[i].sym + ', ' + forlist[i].fl
                            + ', ' + newDis.toFixed(1) + '%, ¥' + rmbPrice
                            + ', ' + forlist[i].cert + ', ' + forlist[i].cert_no + ', ' + placeStr + '；';
                    
                    if (dataCopyStr == '') {
                        dataCopyStr = dataCopy;
                    } else {
                        dataCopyStr = dataCopyStr + '\n' + dataCopy;
                    }
                }
                
                // 添加总计信息
                dataCopyStr += '\n总计: ' + this.data_len + '颗, ' + this.ct_total + 'ct, ¥' + this.totalPrice;
                
                // 复制
                this.copyText(dataCopyStr);
                
                this.$message({
                    message: "Success!",
                    type: "success",
                });
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "Success!",
                    type: "success",
                });
            },
            // 前端处理 选中数据导出
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['Cert No','Place', 'Status', 'Shape', 'Weight', 'Color'
                            , 'Clarity', 'Cut', 'Polish', 'Symmetry', 'Fluorescence', 'Certificate'
                            , 'Sale Rap', 'Sale Discount', 'Sale USD', 'Sale Price'
                            , 'Size', 'Table', 'Depth', 'Ratio']
                    const filterVal = ['cert_no', 'place', 'sale_status', 'shape', 'ct', 'col'
                            ,'cla', 'cut', 'pol', 'sym', 'fl', 'cert'
                            ,'sale_rap', 'new_dis', 'sale_usd' , 'sale_price' 
                            ,'meas', 'table1', 'depth', 'ratio']
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, 'DiamondInfo')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            exportAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['Cert No','Place', 'Status', 'Shape', 'Weight', 'Color'
                            , 'Clarity', 'Cut', 'Polish', 'Symmetry', 'Fluorescence', 'Certificate'
                            , 'Sale Rap', 'Sale Discount', 'Sale USD'
                            , 'Size', 'Table', 'Depth', 'Ratio','Rating','Year']
                    const filterVal = ['cert_no', 'place', 'sale_status', 'shape', 'ct', 'col'
                            ,'cla', 'cut', 'pol', 'sym', 'fl', 'cert'
                            ,'sale_rap', 'new_dis', 'sale_usd'
                            ,'meas', 'table1', 'depth', 'ratio','rating','year']
                    const list = this.diamondAllInfoList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, 'DiamondInfo')
                })
            },
            // 查询全部数据用于导出
            selectAllList() {
                let _this = this;
                util.publicget('/shoppingHK/getDaimondAllList2ByCondition', {
                    username: sessionStorage.getItem('userName'),
                    token: sessionStorage.getItem('token_time'),
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondAllInfoList = res.obj;
                            for(let a = 0; a < _this.diamondAllInfoList.length; a++) {
                                _this.$set(_this.diamondAllInfoList[a],'new_dis',(_this.diamondAllInfoList[a].new_dis.toFixed(2)))
                                _this.$set(_this.diamondAllInfoList[a],'sale_usd',Number(Math.round(_this.diamondAllInfoList[a].sale_usd)))
                                _this.$set(_this.diamondAllInfoList[a],'ct',Number(_this.diamondAllInfoList[a].ct))
                            }
                            _this.exportAll();
                        }else {
                            _this.errorMsg("Failed!");
                        }
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            */
            // 加载分页数据信息
            selectDiamondInfoList() {
                let _this = this;
                //let place = 'HK';
                
                let shape = '';
                if(_this.query.shape === 'Round'){
                    shape = '圆形';
                }else if(_this.query.shape === 'Princess'){
                    shape = '公主方';
                }else if(_this.query.shape === 'Radiant'){
                    shape = '雷迪恩';
                }else if(_this.query.shape === 'Asscher'){
                    shape = '阿斯切';
                }else if(_this.query.shape === 'Marquise'){
                    shape = '马眼';
                }else if(_this.query.shape === 'Oval'){
                    shape = '椭圆形';
                }else if(_this.query.shape === 'Emerald'){
                    shape = '祖母绿';
                }else if(_this.query.shape === 'Pear'){
                    shape = '梨形';
                }else if(_this.query.shape === 'Heart'){
                    shape = '心形';
                }else if(_this.query.shape === 'Cushion'){
                    shape = '垫形';
                }else if(_this.query.shape === 'Triangle'){
                    shape = '三角形';
                }else if(_this.query.shape === 'Others'){
                    shape = '其他';
                }else{
                    shape = _this.query.shape;
                    if(shape){
                        shape = shape.replace('Round','圆形');
                        shape = shape.replace('Princess','公主方');
                        shape = shape.replace('Radiant','雷迪恩');
                        shape = shape.replace('Asscher','阿斯切');
                        shape = shape.replace('Marquise','马眼');
                        shape = shape.replace('Oval','椭圆形');
                        shape = shape.replace('Emerald','祖母绿');
                        shape = shape.replace('Pear','梨形');
                        shape = shape.replace('Heart','心形');
                        shape = shape.replace('Cushion','垫形');
                        shape = shape.replace('Triangle','三角形');
                        shape = shape.replace('Others','其他');
                    }
                }
                
                // 构建查询参数对象
                const queryParams = {
                    sale_status: _this.query.sale_status==''?'在售':_this.query.sale_status,
                    shape: shape,
                    col: _this.query.col,
                    cla: _this.query.cla,
                    cut: _this.query.cut,
                    pol: _this.query.pol,
                    sym: _this.query.sym,
                    fl: _this.query.fl,
                    place: _this.query.place,
                    cert: _this.query.cert,
                    cert_no: _this.query.cert_no,
                    ct1: _this.query.ct1,
                    ct2: _this.query.ct2,
                    page: _this.pager.page,
                    rows: _this.pager.rows
                };
                
                // 将查询参数保存到 sessionStorage，以便在结果页面使用
                sessionStorage.setItem('diamondQueryParams', JSON.stringify(queryParams));
                
                // 跳转到查询结果页面
                _this.$router.push({
                    path: '/phone/diamondShopListMobile',
                    query: queryParams
                });
            },
            /*
            // 批量加入购物车
            savaAllShopInfo() {
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                util.publicget('/shoppingHK/savaShopInfo2', {
                    user: sessionStorage.getItem('userName'),
                    token: sessionStorage.getItem('token_time'),
                    // user: document.cookie.split(';')[1].split('=')[1],
                    id: idStr,
                    cert_no: cert_noStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg("Success!");
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            // 客户批量下单
            savaAllOrderInfo() {
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                _this.dialogTableVisible3 = false;
                this.$refs.addDataForm3.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/shoppingHK/savaOrderInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            token: sessionStorage.getItem('token_time'),
                            id: idStr,
                            cert_no: cert_noStr,
                            vip: _this.addDataForm3.vipCount
                        }, function (res) {
                            if (res.flag) {
                                console.log(res);
                                _this.successMsg("Success!");
                                _this.dialogTableVisible3 = false;
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg("Failed!");
                            }
                        })
                    }
                });
            },
            // 上传rapnet
            uploadRapnetHKFile() {
                let _this = this;
                _this.showMsg('upload Rapnet, please do not repeat the operation!');
                util.publicget('/diamondHK/uploadRapnetFileMultipart3', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        //window.location.href = "/download/data/"+res.file_path;
                        _this.successMsg('Success!');
                    } else {
                        _this.errorMsg('Failed!');
                    }
                });
            },
            */
            /*
            // 加入购物车
            savaShopInfo(rows) {
                let _this = this;
                _this.idStr = rows.id;
                _this.cert_noStr = rows.cert_no;
                _this.sale_priceStr = rows.sale_price;
                util.publicget('/shopping/savaShopInfo', {
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr,
                    cert_no: _this.cert_noStr,
                    sale_price: _this.sale_priceStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg("Success!");
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            */
            // dialog 关闭，数据清空
            closeSava() {
                this.addDataForm3 = {};
                // 条件查询页面不需要在关闭对话框时执行查询
                // this.selectDiamondInfoList();
            },
            /*
            // 查询数据字典 地点
            selectPlaceDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '地点'
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        _this.placeList = res.obj;
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            */
            /*
            // 查询数据字典 汇率
            selectRateDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '汇率'
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        _this.ratevalue = res.obj[0].value;
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            */
            
            // 取消
            resetForm(formName) {
                // 重置所有选择组
                this.checkboxGroup1 = [];
                this.checkboxGroup2 = [];
                this.checkboxGroup3 = [];
                this.checkboxGroup4 = [];
                this.checkboxGroup5 = [];
                this.checkboxGroup6 = [];
                this.checkboxGroup7 = [];
                this.checkboxGroup8 = [];
                this.checkboxGroup9 = [];
                this.checkboxGroup11 = [];
                this.checkboxGroup12 = [];
                this.checkboxGroup13 = [];

                // 重置查询对象
                this.query = {
                    data_dt: [],
                    ct: '',
                    ct1: '',
                    ct2: '',
                    ct3: '',
                    ct4: '',
                    shape: '',
                    col: '',
                    cla: '',
                    cut: '',
                    pol: '',
                    sym: '',
                    fl: '',
                    cert: '',
                    place: '',
                    cert_no: '',
                    addPoint: 0,
                    milkCoffeeGreen: '',
                    noBlack: false,
                    cleanEye: false,
                    hasImage: false,
                    inStock: false,
                    isClosed: false,
                    hasSpecialPrice: false,
                    supplier: '',
                    stockNumber: ''
                };
                
                // 如果表单引用存在，也调用el-form的resetFields方法
                if (this.$refs[formName]) {
                    this.$refs[formName].resetFields();
                }
                
                // 强制更新视图
                this.$forceUpdate();
            },
            /*
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.start_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            },
            // 根据rmb排序
            sortTableFun (column) {
                this.column = column.prop;
                if (column.prop) {
                    if (column.order == 'ascending') {
                        this.order = 'asc'
                    }else if (column.order == 'descending') {
                        this.order = 'desc'
                    }
                    this.selectDiamondInfoList();
                }
            },
            renderHeader (h, {column, $index }) {
                if (column.order == 'ascending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-up'
                            })
                        ]
                    )
                }else if (column.order == 'descending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-down'
                            })
                        ]
                    )
                } else {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort'
                            })
                        ]
                    )
                }
            },
            setPlace(value) {
                this.query.place = value;
            },
            setMilkCoffeeGreen(value) {
                this.query.milkCoffeeGreen = value;
            },
            increasePoint() {
                this.query.addPoint++;
            },
            decreasePoint() {
                if (this.query.addPoint > 0) {
                    this.query.addPoint--;
                }
            },
            rowSelectable(row) {
                // 让所有行都可以被选中，但仅通过点击勾选框
                return true;
            },
            handleRowClick(row, column, event) {
                // 如果点击的是复选框，不做处理
                if (column.type === 'expand' || column.type === 'selection') {
                    return;
                }
                // 切换当前行的选中状态
                this.$refs.refTable.toggleRowSelection(row);
                
                // 可选：添加行选中状态切换
                // this.$refs.refTable.setCurrentRow(row);
            },
            */
            /*
            handleCellClick(row, column, cell, event) {
                // 如果点击的是选择框列，不做额外处理
                if (column.type === 'selection') {
                    return;
                }
                
                // 切换当前行的展开状态
                this.$refs.refTable.toggleRowExpansion(row);
            },*/
            /*
            viewImage(imageUrl) {
                if (!imageUrl) return;
                
                // 设置当前图片URL
                if (imageUrl.startsWith('http')) {
                    this.currentImageUrl = imageUrl;
                } else {
                    // 如果不是完整URL，可能需要添加域名前缀
                    this.currentImageUrl = 'https://您的域名/' + imageUrl;
                }
                
                // 显示对话框
                this.imageDialogVisible = true;
            },
            handleImageDialogClose() {
                this.imageDialogVisible = false;
                this.currentImageUrl = '';
            },
            viewVideo(videoUrl) {
                if (!videoUrl) return;
                
                // 设置当前视频URL
                if (videoUrl.startsWith('http')) {
                    this.currentVideoUrl = videoUrl;
                } else {
                    // 如果不是完整URL，可能需要添加域名前缀
                    this.currentVideoUrl = 'https://您的域名/' + videoUrl;
                }
                
                // 显示对话框
                this.videoDialogVisible = true;
            },
            handleVideoDialogClose() {
                this.videoDialogVisible = false;
                this.currentVideoUrl = '';
                
                // 停止视频播放
                const videoElement = document.querySelector('.diamond-video');
                if (videoElement) {
                    videoElement.pause();
                    videoElement.currentTime = 0;
                }
            }*/
        },
        mounted() {
            //document.body.style.zoom = 0.74;
            // 条件查询页面不需要自动执行查询，只在点击查询按钮时执行
            // this.selectDiamondInfoList();
            //this.selectPlaceDictList();
            // this.selectRateDictList();
            if(sessionStorage.getItem('userType') == 2){
                this.visibleLine = "";
            }
            
            // 检测 Safari 浏览器
            this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            
            // console.log(this.url);
        }
    };
</script>

<style lang="scss" scoped>
    .select-container {
        width: 100%;
        height: 100vh;
        background-color: #fff;
        position: relative;
        overflow-x: hidden;
        overflow-y: auto; /* 允许整体滚动，避免 iOS Safari 底部内容被截断 */
        -webkit-overflow-scrolling: touch;
        
        // 限定所有样式只在 select-container 内生效，避免与其他页面冲突
        * {
            box-sizing: border-box;
        }
    }
    
    /* 移动端固定页面布局 */
    @media screen and (max-width: 768px) {
        .select-container {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100vh;
            height: 100dvh; /* 动态视口高度，适配移动端浏览器地址栏 */
            min-height: 100vh;
            min-height: 100dvh;
            overflow-y: auto;
            overflow-x: hidden;
            -webkit-overflow-scrolling: touch;
        }
        
        .select-container .top-header {
            flex-shrink: 0; /* 防止被压缩 */
        }
        
        .select-container .search-section {
            flex-shrink: 0; /* 防止被压缩 */
        }
        
        .select-container .search-section .search-content {
            flex-shrink: 0; /* 防止被压缩 */
        }
        
        .select-container .search-section .action-buttons {
            flex-shrink: 0; /* 防止被压缩 */
        }
        
        .select-container .filter-section {
            flex-shrink: 0; /* 防止被压缩 */
        }
        
        /* 防止输入框导致布局变化 */
        .select-container .carat-input,
        .select-container .cert-input {
            /deep/ .el-input__inner {
                transform: scale(1); /* 防止iOS Safari自动缩放 */
            }
        }
    }

    .select-container .top-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        background-color: #409EFF;
        padding: 0 15px;
        position: sticky;
        top: 0;
        z-index: 100;

        .header-left,
        .header-right {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #fff;
            font-size: 20px;
            transition: opacity 0.3s;

            &:active {
                opacity: 0.7;
            }
        }

        .header-center {
            flex: 1;
            text-align: center;

            h3 {
                margin: 0;
                color: #fff;
                font-size: 18px;
                font-weight: 500;
            }
        }
    }

    .select-container .diamond-banner {
        width: 100%;
        height: 33.33vh; // 占据屏幕高度的1/3
        position: relative;
        overflow: hidden;
        background-color: #000;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    /**手机屏幕展示 */
    @media screen and (max-width: 748px){
        /* 钻石表格专用样式 */
        .diamond-table {
            border: 1px solid #ddd !important;
            table-layout: fixed !important; /* 确保表格布局固定，列宽均等 */
            
            /* 内容列均分样式 */
            .el-table__body-wrapper .el-table__body td:not(.el-table-column--selection):not(.hidden-expand-column) {
                width: 25% !important;
            }
            
            /* 表头均分样式 */
            .el-table__header-wrapper .el-table__header th:not(.el-table-column--selection):not(.hidden-expand-column) {
                width: 25% !important;
            }
            
            /* 隐藏展开箭头列 */
            .hidden-expand-column {
                width: 0 !important;
                padding: 0 !important;
                margin: 0 !important;
                border: none !important;
                overflow: hidden !important;
                
                .cell {
                    display: none !important;
                }
            }
            
            /* 优化选择框列宽度 */
            .el-table-column--selection {
                width: 35px !important;
                min-width: 35px !important;
                padding-right: 0 !important;
                
                .cell {
                    padding-left: 10px !important;
                    padding-right: 0 !important;
                }
            }
            
            /* 隐藏表头中的展开箭头列 */
            .el-table__header-wrapper .el-table__header th.hidden-expand-column {
                padding: 0 !important;
                width: 0 !important;
                min-width: 0 !important;
                border: none !important;
                overflow: hidden !important;
            }
            
            /* 彻底隐藏展开箭头 */
            .el-table__expand-icon {
                display: none !important;
            }
            
            /* 隐藏证书号列前面的展开图标 */
            .el-table__row .el-table__cell:first-child .cell i.el-icon,
            .el-table__row .el-table__cell:nth-child(2) .cell i.el-icon {
                display: none !important;
            }
            
            .el-table__header-wrapper {
                .el-table__header {
                    th {
                        background-color: #f2f2f2 !important;
                        border-bottom: 1px solid #ddd !important;
                        padding: 8px 0 !important;
                    }
                }
            }
            
            .el-table__body-wrapper {
                td {
                    padding: 5px 0 !important;
                    font-size: 12px !important;
                }
            }
            
            .el-table__row {
                &:nth-child(even) {
                    background-color: rgba(240, 240, 240, 0.5) !important;
                }
            }
            
            /* 展开行样式 */
            .el-table__expanded-cell {
                padding: 10px !important;
                background-color: #fafafa !important;
                
                .demo-table-expand {
                    font-size: 12px !important;
                    
                    .el-form-item {
                        margin-right: 10px !important;
                        margin-bottom: 0 !important;
                        
                        .el-form-item__label {
                            color: #606266 !important;
                        }
                    }
                }
            }
        }
        
        /* 结果卡片样式 */
        .result-card {
            margin-bottom: 10px;
            
            .el-card__body {
                padding: 10px;
            }
            
            .text {
                margin-bottom: 5px;
                
                span {
                    font-size: 14px !important;
                    line-height: 1.5;
                    display: block;
                    float: none !important;
                    margin-top: 5px;
                }
            }
            
            .el-button {
                margin-right: 5px;
                margin-bottom: 5px;
            }
        }
        
        /* 表格卡片样式 */
        .table-card {
            .el-card__body {
                padding: 10px;
            }
        }
        
        .mainds {
            position: relative;
            float: left;
            height: 500px;
        }
        .mainds {
            font-size: 12px;
            font-weight: bold;
            color: #04375f;
            -webkit-transform-origin-x: 0; // 文字居左
            -webkit-transform: scale(0.71);
            transform: scale(0.71);
            transform-origin: left top;
        }
        /* 表格行颜色样式 */
        .el-table {
            /* 奇数行颜色 */
            .el-table__row--striped td {
                background-color: #eaf3fb !important;
            }
            
            /* 偶数行颜色 */
            .el-table__row:not(.el-table__row--striped) td {
                background-color: #f5f7fa !important;
            }
            
            /* 鼠标悬停效果 */
            .el-table__row:hover td {
                background-color: #e6f1fc !important;
            }
            
            /* 表头固定样式 */
            .el-table__header-wrapper {
                .el-table__header {
                    th {
                        background-color: #f0f0f0 !important;
                        color: #333 !important;
                        font-weight: bold !important;
                        border-bottom: 2px solid #ddd !important;
                    }
                }
            }
            
            /* 滚动条样式 */
            .el-table__body-wrapper::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            
            .el-table__body-wrapper::-webkit-scrollbar-thumb {
                background-color: #c0c4cc;
                border-radius: 3px;
            }
            
            .el-table__body-wrapper::-webkit-scrollbar-track {
                background-color: #f5f5f5;
            }
            
            /* 单元格边框和内容对齐 */
            td {
                border-color: #ebeef5 !important;
                padding: 4px 0 !important;
            }
            
            /* 表格边框 */
            border: 1px solid #ebeef5 !important;
            border-radius: 4px;
            overflow: hidden;
        }
    }

    /* 移动端查询界面样式 - 已使用新的顶部导航栏，移除旧样式 */

    .select-container .search-section {
        padding: 0px;
        background-color: #f5f5f5; /* 浅灰色背景，与白色卡片形成对比 */
        /* 固定高度：屏幕高度减去header */
        height: calc(100vh - 50px);
        height: calc(100dvh - 50px); /* 动态视口高度，适配移动端浏览器地址栏 */
        min-height: calc(100vh - 50px);
        min-height: calc(100dvh - 50px);
        position: relative;
        display: flex;
        flex-direction: column;
        overflow: visible; /* Safari 中 overflow: hidden 会截断底部按钮，改为 visible */
        
        .search-content {
            flex: 1;
            overflow-y: auto; /* 允许垂直滚动 */
            overflow-x: hidden; /* 禁止水平滚动 */
            padding: 12px;
            /* 为底部按钮区域预留空间，确保内容不会被按钮遮挡，100px 是按钮区域高度 */
            padding-bottom: calc(12px+ env(safe-area-inset-bottom, 0px));
            -webkit-overflow-scrolling: touch; /* iOS平滑滚动 */
            
            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
                width: 6px;
            }
            
            &::-webkit-scrollbar-thumb {
                background-color: #c0c4cc;
                border-radius: 3px;
                
                &:hover {
                    background-color: #a0a4a8;
                }
            }
            
            &::-webkit-scrollbar-track {
                background-color: #f5f5f5;
                border-radius: 3px;
            }
        }
        
        .action-buttons {
            position: relative; /* 保持相对定位 */
            background: white;
            padding: 12px 15px;
            /* 默认底部 padding，其他浏览器使用较小的值 */
            padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
            border-top: 1px solid #eee;
            box-shadow: 0 -2px 8px rgba(0,0,0,0.1);
            flex-shrink: 0; /* 防止按钮区域被压缩 */
            display: flex;
            gap: 10px;
            margin: 0; /* 移除负边距 */
            border-radius: 8px 8px 0 0; /* 顶部圆角，底部直角 */
            z-index: 10; /* 确保按钮在最上层 */
            
            &.safari-only {
                padding-bottom: calc(12px + 110px + env(safe-area-inset-bottom, 0px));
            }
        }
    }

    .select-container .filter-section {
        margin-bottom: 12px; /* 筛选区域之间的间距 */
        background-color: white;
        border-radius: 8px;
        padding: 12px 15px;
        box-shadow: 0 1px 2px rgba(0,0,0,0.08); /* 更柔和的阴影 */
        
        &.action-buttons {
            margin-bottom: 0; /* 按钮区域不需要底部间距 */
            margin-top: 0; /* 确保与上方内容无缝衔接 */
        }
    }

    .select-container .filter-title {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 12px;
        color: #333;
        border-bottom: none; /* 移除底部边框，更简洁 */
        padding-bottom: 0;
    }

    .select-container .filter-content {
        display: flex;
        flex-wrap: wrap;
        gap: 8px; /* 增加间距，使按钮更易点击 */
    }

    /* 形状选择样式 */
    .select-container .shape-content {
        justify-content: flex-start; /* 左对齐，更整齐 */
        gap: 8px; /* 统一使用gap间距 */
    }

    .select-container .shape-item {
        width: calc((100% - 40px) / 6); /* 6列布局，考虑gap */
        min-width: 50px;
        height: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        cursor: pointer;
        padding: 3px 5px;
        transition: all 0.2s;
        background-color: #fff;
        margin: 0; /* 移除margin，使用gap */
    }

    .select-container .shape-item.active {
        background-color: #e6f4ff;
        border-color: #409EFF;
        box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
    }
    
    .select-container .shape-item:active {
        transform: scale(0.95);
    }

    .select-container .shape-icon {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto 20px auto; /* 增加底部间距，让图标和文字分开 */
        flex-shrink: 0;
    }

    .select-container .shape-name {
        font-size: 11px;
        text-align: center;
        margin-top: 3px;
        margin-bottom: 0;
        line-height: 1.2;
        flex-shrink: 0;
    }

    .select-container .el-icon-round, .select-container .el-icon-princess, .select-container .el-icon-radiant,
    .select-container .el-icon-asscher, .select-container .el-icon-marquise, .select-container .el-icon-oval,
    .select-container .el-icon-emerald, .select-container .el-icon-pear1, .select-container .el-icon-heart,
    .select-container .el-icon-cushion, .select-container .el-icon-others, .select-container .el-icon-triangle {
        background-size: 30px 30px;
        width: 30px;
        height: 30px;
        margin: 0;
    }

    /* 克拉选择样式 */
    .select-container .carat-range {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        margin-bottom: 10px;
        width: 100%;
    }

    .select-container .carat-item {
        padding: 8px 10px;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        cursor: pointer;
        text-align: center;
        flex: 1;
        min-width: 45px;
        background-color: #fff;
        font-size: 14px;
        transition: all 0.2s;
    }

    .select-container .carat-item.active {
        background-color: #409EFF;
        border-color: #409EFF;
        color: #fff;
        font-weight: 500;
    }
    
    .select-container .carat-item:active {
        transform: scale(0.95);
    }

    .select-container .carat-custom {
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
    }

    .select-container .carat-input {
        max-width: 80px;
    }

    .select-container .separator {
        margin: 0 5px;
    }

    /* 颜色、净度、切工等共用样式 */
    .select-container .color-item, .select-container .clarity-item, .select-container .cut-item, .select-container .polish-item, .select-container .symmetry-item, .select-container .fluorescence-item, .select-container .cert-item, .select-container .location-item, .select-container .other-item, .select-container .quick-item {
        padding: 8px 12px;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        cursor: pointer;
        text-align: center;
        background-color: #fff;
        font-size: 14px;
        transition: all 0.2s;
        min-width: 50px;
    }

    .select-container .color-item.active, .select-container .clarity-item.active, .select-container .cut-item.active, .select-container .polish-item.active, .select-container .symmetry-item.active, .select-container .fluorescence-item.active, .select-container .cert-item.active, .select-container .location-item.active, .select-container .other-item.active, .select-container .quick-item.active {
        background-color: #409EFF;
        border-color: #409EFF;
        color: #fff;
        font-weight: 500;
    }
    
    .select-container .color-item:active, .select-container .clarity-item:active, .select-container .cut-item:active, .select-container .polish-item:active, .select-container .symmetry-item:active, .select-container .fluorescence-item:active, .select-container .cert-item:active, .select-container .location-item:active, .select-container .other-item:active, .select-container .quick-item:active {
        transform: scale(0.95);
    }

    /* 证书号输入框样式 */
    .select-container .cert-input {
        width: 100%;
        
        /deep/ .el-input__inner {
            border-radius: 6px;
            border: 1px solid #e0e0e0;
            padding: 10px 12px;
            font-size: 14px;
            
            &:focus {
                border-color: #409EFF;
            }
        }
    }
    
    /* 移动端输入框字体大小修复，防止iOS Safari自动放大 */
    @media screen and (max-width: 748px) {
        .select-container .carat-input {
            /deep/ .el-input__inner {
                font-size: 16px;
            }
        }
        
        .select-container .cert-input {
            /deep/ .el-input__inner {
                font-size: 16px;
            }
        }
    }

    /* 加点控制样式 */
    .select-container .point-control {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .select-container .point-value {
        width: 40px;
        text-align: center;
        font-size: 16px;
    }

    /* 操作按钮样式 - 已在 .search-section .action-buttons 中定义 */
    .select-container .search-btn, .select-container .reset-btn {
        flex: 1;
        height: 45px;
        font-size: 16px;
        border-radius: 4px;
    }

    .select-container .search-btn {
        background-color: #409EFF;
        border-color: #409EFF;
    }

    /* 复选框组样式 */
    .select-container .checkbox-group {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        margin-top: 10px;
    }


    .el-dialog{
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
    .select-container .el-icon-round {
        background:url('../../assets/images/cut2/round.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-princess {
        background:url('../../assets/images/cut2/princess.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-radiant {
        background:url('../../assets/images/cut2/radiant.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-asscher {
        background:url('../../assets/images/cut2/asscher.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-marquise {
        background:url('../../assets/images/cut2/marquise.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-oval {
        background:url('../../assets/images/cut2/oval.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-emerald {
        background:url('../../assets/images/cut2/emerald.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-pear1 {
        background:url('../../assets/images/cut2/pear1.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-heart {
        background:url('../../assets/images/cut2/heart.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-cushion {
        background:url('../../assets/images/cut2/cushion.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-others {
        background:url('../../assets/images/cut2/others.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .select-container .el-icon-triangle {
        background:url('../../assets/images/cut2/triangle.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    /* 修改分页组件样式 */
    @media screen and (max-width: 748px) {
        .block.tar.mar_t {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 10px 0;

            .el-pagination {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 5px;
                padding: 5px;
                white-space: normal;
                width: 100%;
                
                /* 总数和每页条数 */
                .el-pagination__total,
                .el-pagination__sizes {
                    height: 28px;
                    margin: 0 15px;
                }
                
                /* 页码按钮组 */
                .el-pager {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    margin: 0;
                    
                    li {
                        min-width: 28px;
                        height: 28px;
                        line-height: 28px;
                        margin: 0 2px;
                        
                        &.active {
                            background-color: #409EFF;
                            color: #fff;
                        }
                    }
                }
                
                /* 上一页下一页按钮 */
                .btn-prev,
                .btn-next {
                    min-width: 28px;
                    height: 28px;
                    line-height: 28px;
                    padding: 0;
                    margin: 0 2px;
                }
                
                /* 跳转页输入框 */
                .el-pagination__jump {
                    margin: 0 5px;
                    height: 28px;
                    line-height: 28px;
                    
                    .el-input {
                        width: 50px;
                        margin: 0 5px;
                        
                        input {
                            height: 28px;
                            line-height: 28px;
                            text-align: center;
                        }
                    }
                }

                /* 特小屏幕适配 */
                @media screen and (max-width: 375px) {
                    .el-pagination__sizes {
                        display: none; // 隐藏每页条数选择器
                    }
                    
                    .el-pagination__jump {
                        margin: 5px 0;
                    }
                }
            }
        }
    }

    .diamond-mobile-table {
        width: 100%;
        margin: 0;
        padding: 0;
        
        /* 隐藏展开箭头 */
        .el-table__expand-icon {
            display: none;
        }
        
        /* 内容紧凑化 */
        .el-table__cell {
            padding: 2px 0 !important;
        }
        
        /* 表头样式优化 */
        .el-table__header-wrapper th {
            background-color: #f8f8f8 !important;
            padding: 5px 0 !important;
        }
        
        /* 选中行样式 */
        .el-table__row.current-row {
            background-color: #f0f7ff !important;
        }
        
        /* 奇偶行样式 */
        .el-table__row:nth-child(odd) {
            background-color: #fff;
        }
        
        .el-table__row:nth-child(even) {
            background-color: #fafafa;
        }
        
        /* 点击时的高亮效果 */
        .el-table__row:active {
            background-color: #e6f1fc;
        }
        
        /* 价格区域样式 */
        .price-area {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .media-links {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 3px;
    }
    
    .image-link, .vedio_link {
        cursor: pointer;
        
        i {
            color: #409EFF;
            font-size: 14px;
            &:hover {
                color: #66b1ff;
            }
        }
    }
    
    .vedio_link .el-icon-video-camera {
        color: #F56C6C;
        &:hover {
            color: #f78989;
        }
    }

    .image-dialog-content {
        display: flex;
        justify-content: center;
        align-items: center;
        
        .diamond-image {
            max-width: 100%;
            max-height: 70vh; // 限制高度为视口高度的70%
            object-fit: contain;
        }
    }
    
    .video-dialog-content {
        display: flex;
        justify-content: center;
        align-items: center;
        
        .diamond-video {
            max-width: 100%;
            max-height: 70vh; // 限制高度为视口高度的70%
            object-fit: contain;
        }
    }

    // 调整对话框样式
    .el-dialog__header {
        padding: 15px 20px 10px;
        text-align: center;
        border-bottom: 1px solid #ebeef5;
    }

    .el-dialog__body {
        padding: 15px;
    }

    // 适配移动端样式
    @media screen and (max-width: 748px) {
        .el-dialog {
            width: 95% !important;
            margin-top: 20vh !important;
        }
        
        // 针对 iPhone Safari 的特殊处理
        @supports (-webkit-touch-callout: none) {
            .select-container {
                /* iOS Safari专用，确保填充整个视口 */
                min-height: -webkit-fill-available;
            }
            
            .select-container .search-section {
                /* 使用 -webkit-fill-available 适配 iOS Safari */
                height: calc(-webkit-fill-available - 50px);
                min-height: calc(-webkit-fill-available - 50px);
            }
            
            .select-container .search-section .action-buttons {
                /* Safari 浏览器需要更多的底部空间 */
                padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
            }
            
            .select-container .search-section .search-content {
                /* 确保内容区域也有足够的底部空间 */
                padding-bottom: calc(12px -5px + env(safe-area-inset-bottom, 0px));
            }
        }
        
        // 针对 iOS 设备的特殊处理
        @media screen and (-webkit-min-device-pixel-ratio: 2) {
            .select-container .search-section {
                /* 使用 100dvh 代替 100vh，在 iOS Safari 中更准确 */
                height: calc(100dvh - 50px);
                min-height: calc(100dvh - 50px);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/phone/diamondShopSelect.vue